import * as R from 'ramda';
import { format } from 'date-fns/fp';

/**
 * isProd :: () -> Boolean
 */
export const isProd = () => process.env.NODE_ENV === 'production';

/**
 * isUnauthorizedError :: Error -> Boolean
 */
export const isUnauthorizedError = R.pathEq(['response', 'status'], 401);

export const getErrorMessage = R.pipe(
  R.pathOr('Server error', ['response', 'data', 'error', 'message']),
  msg => new Error(msg),
  err => Promise.reject(err),
);

/**
 * formatMonthYearStr :: (Number, Number) -> Number
 */
export const formatMonthYearStr = (month, year) => format('MMM/yyyy', new Date(year, month - 1));



// WEBPACK FOOTER //
// ./src/api/utils/index.js